export const splitLast = (inputArray: []) => {
  const allButLast = inputArray.slice(0, -1);
  const last = inputArray[inputArray.length - 1];
  return [allButLast, last];
};
